import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3213ffa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-background" }
const _hoisted_2 = { class: "tradist-container" }
const _hoisted_3 = { class: "my-items__wrapper" }
const _hoisted_4 = { class: "my-items__user-bio" }
const _hoisted_5 = {
  key: 0,
  class: "my-items__user-bio--avatar"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "w-full text-center" }
const _hoisted_8 = { class: "inline text-2xl text-white" }
const _hoisted_9 = { class: "my-items__content" }
const _hoisted_10 = {
  key: 0,
  class: "token-list-empty"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" You haven't created any NFTs. Create one ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" here! ")
const _hoisted_13 = { class: "w-full text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" More ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_ShareDropdown = _resolveComponent("ShareDropdown")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.config.USER_AVATAR_ENABLED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.user.avatar,
                  alt: _ctx.user.username
                }, null, 8, _hoisted_6),
                (_ctx.doesUserHaveShareLinks)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ShareIcon, {
                        class: "my-items__user-bio--avatar--share",
                        onClick: _ctx.openShareDropdown
                      }, null, 8, ["onClick"]),
                      (_ctx.isShareDropdownOpen)
                        ? (_openBlock(), _createBlock(_component_ShareDropdown, {
                            key: 0,
                            onClose: _ctx.closeShareDropdown
                          }, null, 8, ["onClose"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userAddress), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_BaseCard, {
              class: "mr-5 mb-8",
              assetUrl: item.asset.path,
              sellerAddress: item.owner,
              assetPrice: item.price,
              assetTitle: item.title,
              assetDescription: item.description,
              assetTags: item.tags,
              tokenId: item.tokenId,
              contractAddress: item.contractAddress,
              fixedHeight: "",
              newBid: false,
              key: index
            }, null, 8, ["assetUrl", "sellerAddress", "assetPrice", "assetTitle", "assetDescription", "assetTags", "tokenId", "contractAddress"]))
          }), 128)),
          (_ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, [
                  _hoisted_11,
                  _createVNode(_component_router_link, {
                    class: "token-list-empty__link",
                    to: "/create"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.hasMorePages)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                shadow: "",
                onClick: _ctx.handleMoreButton
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}